export enum ReportInterval {
  Daily = 'daily',
  Hourly = 'hourly',
  Monthly = 'monthly',
  Weekly = 'weekly',
}

export default ReportInterval;
